import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import { useCookies } from "vue3-cookies";

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { requiresAuth: true, title: "Home" },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: { title: "Login" },
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/Auth.vue"),
    meta: { title: "Signing in" },
  },
  {
    path: "/:meet",
    name: "meet",
    component: () => import("../views/Meeting.vue"),
    meta: { requiresAuth: true, title: "Meet" },
    children: [
      {
        path: "preview",
        name: "preview",
        component: () => import("../components/Meet/Preview.vue"),
        meta: { title: "Preview" },
      },
      {
        path: "meeting",
        name: "meeting",
        component: () => import("../components/Meet/Meeting.vue"),
        meta: { title: "Meeting" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Set document title
  document.title = to.meta.title ? `${to.meta.title} · AcadaPower Live` : "AcadaPower Live";

  // Check if route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Get API key from cookies to check authentication
    const api_key = useCookies().cookies.get("api_key");
    const token = useCookies().cookies.get("token");

    if (api_key && token) {
      // User is authenticated, proceed to the next route
      next();
    } else {
      // User is not authenticated, redirect to the login page
      // Back to where they were going once they have signed in — a
      // meeting link opened while signed out lands in the meeting.
      next({ name: "login", query: to.fullPath !== "/home" ? { next: to.fullPath } : {} });
    }
  } else {
    // The route does not require authentication, proceed to the next route
    next();
  }
});

export default router;
